import { render, staticRenderFns } from "./TableBeneficiarios.vue?vue&type=template&id=68551676"
import script from "./TableBeneficiarios.vue?vue&type=script&lang=js"
export * from "./TableBeneficiarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports